import {API_HOST, API_HOST_FZK, API_HOST_DPC} from "./index";

// const PROXY_URL = '/chen_guihao';  //前端代理前缀
const PROXY_URL = '/zou_xiang' ;  //前端代理前缀
// const PROXY_URL = '/chen_ding_feng' ;  //前端代理前缀
// const PROXY_URL = '/online';
// const PROXY_URL = '';//文生
let BASE_URL = '' // 顾客url
let LOGIN_URL = '' // 登录url
let SHOW_WAY = '/fzkCustomer';  // 商家注册
// let gateway = '/fzkCustomer' // 顾客统一前缀
let gateway = API_HOST_FZK + '/fzkCustomer'  // 顾客统一前缀
let dpcGateway = API_HOST_DPC + '/dpcGateway'; // 大配餐前缀
let archiveGateway = API_HOST + '/archiveGateway'; // 档案前缀

let officialWebsite = 'http://yhylh5.yhylht.cn';//官网
if (process.env && process.env.NODE_ENV === 'development') {
  BASE_URL = PROXY_URL + gateway
  LOGIN_URL = PROXY_URL
  SHOW_WAY = PROXY_URL + SHOW_WAY
  dpcGateway = '/dpcGateway'
} else {
  LOGIN_URL = API_HOST + '';
  BASE_URL = API_HOST_FZK + '/fzkCustomer';
  dpcGateway = API_HOST_DPC + '/dpcGateway'
}

export {
  BASE_URL,
  LOGIN_URL,
  dpcGateway,
  archiveGateway,
  officialWebsite
}



// WEBPACK FOOTER //
// ./src/config/env.uri.js